<template>
  <div class="contents col-sm-12 notification-rectangle">
    <div class="col-12">
      <div class="row pt-30">
        <div class="col-md-6 pl-0 notification-settings">
          Notification settings
        </div>
        <div class="col-md-3 notification-dropdown margin-left-auto">
          <select class="form-control custom-dropdown" v-model="selectedStudyId">
            <option v-for="(e, index) in filteredUserSite" :value="e.studyId" :key="index">{{ e.studyName }}</option>
          </select>
        </div>
        <div v-if="isSiteTeam" class="col-md-3 notification-dropdown">
          <select class="form-control custom-dropdown" v-model="selectedSiteId">
            <option v-for="(e, index) in studySites" :value="e.siteId" :key="index">{{ e.userDefineSiteId }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div
        v-for="(item, index) in notificationList"
        :key="index"
        class="d-flex"
        :class="{
          'border-bottom': item.sortOrder != notificationList[notificationList.length - 1].sortOrder
        }"
      >
        <div class="row email-setting pt-21 mr-auto">
          {{ item.notificationText }}
        </div>
        <div class="on-off">
          <div class="t-switch off"><label>Off</label></div>
          <div class="t-switch">
            <label class="switch">
              <input type="checkbox" :disabled="item.notificationKey == 'PATICIPANT_WITHDRAW' || item.notificationKey == 'PARTICIPANT_TRANSFER' || item.active == false || isLoading" v-model="item.status" @change="onChangeNotification(item)" />
              <div class="slider round"></div>
            </label>
          </div>
          <div class="t-switch on"><label>On</label></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "ProfileNotificationSetting",
  props: ["userSite"],
  data() {
    return {
      siteNotificationDetails: {},
      isSiteTeam: true,
      siteId: "",
      studyId: "",
      userId: "",
      isLoading: false,
      notificationList: [],
      selectedStudyId: null,
      studySites: null,
      selectedSiteId: null,
      maxNum: 0,
      filteredUserSite: []
    };
  },
  computed: {
    ...mapGetters(["user"])
  },

  mounted() {
    if (this.userSite) {
      this.filteredUserSite = _.uniqBy(this.userSite, "studyId");
      this.selectedStudyId = this.filteredUserSite[0].studyId;
      this.studySites = _.filter(this.userSite, ["studyId", this.selectedStudyId]);
      this.selectedSiteId = this.studySites[0].siteId;
    }
    this.checkRoleAndGetDetails();
  },
  watch: {
    selectedStudyId() {
      this.studySites = _.filter(this.userSite, ["studyId", this.selectedStudyId]);
      this.selectedSiteId = this.studySites[0].siteId;
      this.checkRoleAndGetDetails();
    },
    selectedSiteId() {
      this.checkRoleAndGetDetails();
    },
    notificationList: {
      handler(newValue) {
        newValue.forEach(item => {
          if (item.active == false) {
            item.status = false;
          }
        });
      },
      deep: true
    }
  },
  methods: {
    getStudyTeamNotifications() {
      nprogress.start();
      if (this.selectedStudyId) {
        this.$api.getStudyTeamNotification(this.userId, this.selectedStudyId).then(
          response => {
            this.notificationList = _.sortBy(response.body, "sortOrder");
            nprogress.done();
          },
          error => {
            nprogress.done();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study user notifications.");
          }
        );
      }
      nprogress.done();
    },
    getSiteTeamNotifications() {
      const self = this;
      nprogress.start();
      this.$api.getAllStudiesFact().then(
        response => {
          self.studyId = response.body[0].studyId;
          self.$api.getSiteTeamNotification(this.selectedStudyId, this.selectedSiteId, self.userId).then(
            response => {
            if (response && response.body) {  
              const resp = response.body.filter(item => item.isEnabled);
              self.notificationList = _.sortBy(resp, "sortOrder");
              if (self.notificationList && self.notificationList.length > 0 && self.notificationList[self.notificationList.length - 1].sortOrder != undefined) {
                self.maxNum = self.notificationList[self.notificationList.length - 1].sortOrder;
              }
              nprogress.done();
            }
            },
            error => {
              nprogress.done();
              self.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting site user notifications.");
            }
          );
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study details");
        }
      );
    },
    checkRoleAndGetDetails() {
      this.userId = this.user.id;
      if (this.user.userRole === "Pi" || this.user.userRole === "SubPi" || this.user.userRole === "StudyCoordinator" || this.user.userRole === "HomeHealth" || this.user.userRole === "CallCenter") {
        this.isSiteTeam = true;
        this.getSiteTeamNotifications();
      }
      if (this.user.userRole === "Cra" || this.user.userRole === "Dm" || this.user.userRole === "Quality" || this.user.userRole === "CraUB") {
        this.isSiteTeam = false;
        this.getStudyTeamNotifications();
      }
    },
    onChangeNotification(item) {
      this.isLoading = true;
      const notificationItem = [];
      notificationItem.push(item);
      if (this.isSiteTeam) {
        nprogress.start();
        this.$api.saveSiteTeamNotification(this.selectedStudyId, this.selectedSiteId, this.userId, this.notificationList).then(
          () => {
            this.getSiteTeamNotifications();
            nprogress.done();
            this.isLoading = false;
          },
          error => {
            nprogress.done();
            this.isLoading = false;
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving site user notifications.");
          }
        );
      } else {
        this.isLoading = true;
        nprogress.start();
        this.$api.saveStudyTeamNotification(this.userId, this.selectedStudyId, this.notificationList).then(
          () => {
            this.getStudyTeamNotifications();
            nprogress.done();
            this.isLoading = false;
          },
          error => {
            nprogress.done();
            this.isLoading = false;
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving study user notifications.");
          }
        );
      }
    }
  }
};
</script>

<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss">
.custom-dropdown {
  border-radius: 4px;
  border: solid 1px #d3dfe4;
  background-color: #fff;
  width: 166px;
}
.notification-dropdown {
  justify-content: flex-end;
  display: flex;
  padding-right: 0px;
}
.dropdown-setting {
  margin-inline-start: 700px;
}
.notification-rectangle {
  width: 1102px;
  min-height: 200px;
  background-color: #ffffff;
}
.contents {
  margin-left: 19px;
  margin-right: 19px;
  color: #959fa4;
}
.notification-settings {
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #666669;
}
.email-setting {
  width: 400px;
  height: 20px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666669;
}
.switch {
  position: relative;
  display: inline-block;
  margin-top: 10px;
  width: 32px;
  height: 20px;
  margin-left: 6px;
  margin-right: 6px;
  &:disabled {
    cursor: default !important;
  }
}
.switch input {
  display: none;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: -1px;
  left: -2px;
  right: -3px;
  bottom: -1px;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked:disabled + .slider {
  border: 2px solid #48bf7a;
  opacity: 0.5;
  cursor: default;
}
input:checked + .slider:before {
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.checkbox {
  width: 12px;
  height: 12px;
}
.col-12 {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
  padding: 11px 31px 11px 31px;
}
.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}
.on {
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
  margin-top: 10px;
}
.off {
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
  margin-top: 10px;
}
.t-switch {
  display: block;
}
.on-off {
  text-align: center;
  display: flex;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 90px;
}
.pt-21 {
  padding-top: 21px !important;
}
@media (min-width: 768px) and (max-width: 1111px) {
  .notification-rectangle {
    width: 95%;
  }
}
.margin-left-auto {
  margin-left: auto;
}
</style>
